import { RateLimiterRes } from 'rate-limiter-flexible';
import { ZmyleErrorId } from 'utils/constants';

export const tooManyRequestsError: ZmyleError = {
  errorMsg: 'Too many requests',
  errorId: ZmyleErrorId.TOO_MANY_REQUESTS,
  status: 429,
  occurredAt: '',
};

interface SetRateLimitHeadersParams {
  headers?: Headers;
  rateLimiter: RequestRateLimiter['rateLimiter'];
  rateLimitRes: RateLimiterRes;
  suffix?: string;
}

export const rateLimitHeadersName = {
  limit: 'X-RateLimit-Limit',
  remaining: 'X-RateLimit-Remaining',
  reset: 'X-RateLimit',
} as const;

export const setRateLimitHeaders = (params: SetRateLimitHeadersParams) => {
  const { headers, rateLimiter, rateLimitRes, suffix = '' } = params;

  if (!rateLimiter || !rateLimitRes) return;

  headers?.append(
    `${rateLimitHeadersName.limit}-${suffix}`,
    String(rateLimiter.points),
  );
  headers?.append(
    `${rateLimitHeadersName.remaining}-${suffix}`,
    String(rateLimitRes.remainingPoints),
  );
  headers?.append(
    `${rateLimitHeadersName.reset}-${suffix}`,
    String(new Date(Date.now() + rateLimitRes.msBeforeNext).getTime()),
  );
};
